import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import {
  c2cPushSteps,
  settingsSBPSteps,
  accountLinkingSteps,
  m2mPullSteps,
  m2mPushSteps,
} from "./flowsSteps"
import { TFlowName, TRoutingType } from "./types"

export const initialState: TRoutingType = {
  currentFlow: "",
  routes: {
    c2cPush: {
      currentStep: "",
      initStep: c2cPushSteps.getLastTransfers.name,
      steps: c2cPushSteps,
    },
    settingsSBP: {
      currentStep: "",
      initStep: settingsSBPSteps.sbpSettings.name,
      steps: settingsSBPSteps,
    },
    accountLinking: {
      currentStep: "",
      initStep: accountLinkingSteps.linkingBankSelection.name,
      steps: accountLinkingSteps,
    },
    refillM2M: {
      currentStep: "",
      initStep: m2mPullSteps.refill.name,
      steps: m2mPullSteps,
    },
    m2mPush: {
      currentStep: "",
      initStep: m2mPushSteps.сonfirmTransfer.name,
      steps: m2mPushSteps,
    },
  },
}

const routingSlice = createSlice({
  name: "routing",
  initialState,
  reducers: {
    setCurrentFlow: (state, action: PayloadAction<TFlowName | "">) => {
      state.currentFlow = action.payload
    },
    setCurrentStep: (state, action: PayloadAction<string>) => {
      state.routes[state.currentFlow as TFlowName].currentStep = action.payload
    },
    setNextStep: (state, action: PayloadAction<string | undefined>) => {
      const { nextStep } =
        state.routes[state.currentFlow as TFlowName].steps[
          state.routes[state.currentFlow as TFlowName].currentStep
        ]
      if (action.payload) {
        state.routes[state.currentFlow as TFlowName].currentStep =
          action.payload
        return
      }
      if (nextStep) {
        state.routes[state.currentFlow as TFlowName].currentStep = nextStep
      } else {
        state.routes[state.currentFlow as TFlowName].currentStep = ""
      }
    },
    setPreviousStep: (state) => {
      const { previousStep } =
        state.routes[state.currentFlow as TFlowName].steps[
          state.routes[state.currentFlow as TFlowName].currentStep
        ]
      if (previousStep) {
        state.routes[state.currentFlow as TFlowName].currentStep = previousStep
      } else {
        state.routes[state.currentFlow as TFlowName].currentStep = ""
      }
    },
    resetSteps: () => initialState,
  },
})

export const {
  setCurrentFlow,
  setCurrentStep,
  setNextStep,
  setPreviousStep,
  resetSteps,
} = routingSlice.actions

export default routingSlice.reducer
